app.service('disclaimerService', [ 'CONSTANTS', 'portalHelper',
  function (CONSTANTS, portalHelper) {
    const service = this;

    const createBasicDisclaimerElement = function (type, content, options) {
      return {
        type: type,
        content_html: content,
        options: options
      };
    };

    const createBasicDisclaimerOption = function (content, doesTerminateSurvey) {
      return {
        content_html: content,
        terminates_survey: doesTerminateSurvey
      };
    };

    // Sanitizes element from the disclaimer
    const sanitizeElement = function (el) {
      let options = null;
      if (el.options != null && el.options.length > 0) {
        options = [];
        for (let p=0; p<el.options.length; p++) {
          options.push(createBasicDisclaimerOption(
            el.options[p].content_html, el.options[p].terminates_survey));
        }
      }

      return createBasicDisclaimerElement(el.type, el.content_html, options);
    };

    /***
     * Creates a disclaimer element object
     * @param type
     * @param content
     * @param options
     * @param isNew
     * @return {{options, type, content_html}}
     */
    service.create_disclaimer_element = function (type, content, options, isNew) {
      const result = createBasicDisclaimerElement(type, content, options);

      // A random ID is generated (not persisted to DB) to aid with the management of the UI elements
      result.id = portalHelper.generate_random_id();
      if (isNew === true) {
        result.is_new = true;
      }

      return result;
    };

    /***
     * Creates an option for the disclaimer element
     * @param content
     * @param doesTerminateSurvey
     * @return {{terminates_survey, content_html}}
     */
    service.create_disclaimer_option = function (content, doesTerminateSurvey) {
      const result = createBasicDisclaimerOption(content, doesTerminateSurvey);

      // A random ID is generated (not persisted to DB) to aid with the management of the UI elements
      result.id = portalHelper.generate_random_id();
      return result;
    };

    /***
     * Creates a new disclaimer object
     * @param ownerId
     * @return {{owner_id, elements: [], name: string, id: number, client_id: null}}
     */
    service.create_new_disclaimer = function (ownerId) {
      return {
        client_id: null,
        id: 0,
        name: '',
        owner_id: ownerId,
        elements: []
      };
    };

    /***
     * Sanitizes a disclaimer object and converts it in a format that the API expects.
     * @param disclaimer
     * @return {{owner_id, elements: *[], name: string, id: number, client_id: null}|null}
     */
    service.sanitize_disclaimer = function (disclaimer) {
      if (disclaimer == null) {
        return null;
      }

      const result = this.create_new_disclaimer(disclaimer.owner_id);
      result.name = disclaimer.name;
      result.owner_id = disclaimer.owner_id;
      result.id = disclaimer.id;

      // Going through all the elements here
      if (disclaimer.elements && disclaimer.elements.length > 0) {
        for (let i=0; i<disclaimer.elements.length; i++) {
          result.elements.push(sanitizeElement(disclaimer.elements[i]));
        }
      }

      return result;
    };

    /***
     * Adds IDs and other params required by the UI to render and manipulate disclaimers
     * @param disclaimer
     */
    service.prepare_disclaimer_for_ui = function (disclaimer) {
      const result = angular.copy(disclaimer);

      if (result.elements != null && result.elements.length > 0) {
        result.elements.forEach(function (el) {
          if (!el.id) {
            // A random ID is generated (not persisted to DB) to aid with the management of the UI elements
            el.id = portalHelper.generate_random_id();
          }

          if (el.options != null && el.options.length > 0) {
            el.options.forEach(function (op) {
              if (!op.id) {
                // A random ID is generated (not persisted to DB) to aid with the management of the UI elements
                op.id = portalHelper.generate_random_id();
              }
            });
          }
        });
      }

      return result;
    };

    /***
     * Validates a list of disclaimer elements and returns null if everything is good.
     * @param disclaimerElements
     * @return {{valid: boolean, message: string}}
     */
    service.validate_disclaimer_elements = function (disclaimerElements) {
      const result = {
        valid: true,
        message: ''
      };

      // Empty disclaimers are OK
      if (disclaimerElements == null || disclaimerElements.length === 0) {
        return result;
      }

      // Checking if any content_html is empty
      for (let i = 0; i < disclaimerElements.length; i++) {
        if (disclaimerElements[i].content_html === ''
          && disclaimerElements[i].type !== CONSTANTS.disclaimerElementTypes.PAGE_BREAK) {
          result.message = 'All elements must have some text';
          result.valid = false;
          return result;
        }

        if (disclaimerElements[i].type === CONSTANTS.disclaimerElementTypes.QUESTION) {
          let allOptionsTerminateSurvey = true;
          for (let j = 0; j < disclaimerElements[i].options.length; j++) {
            const option = disclaimerElements[i].options[j];
            // Checking to see if all options terminate survey
            allOptionsTerminateSurvey = allOptionsTerminateSurvey & option.terminates_survey;
            if (option.content_html === '' ) {
              result.valid = false;
              result.message = 'All question options must have some text.';
              return result;
            }
          }

          if (allOptionsTerminateSurvey) {
            result.message = 'One or more questions have all options that terminate the survey. Atleast one of the options in a question should let the payer continue.';
            result.valid = false;
            return result;
          }
        }
      }

      return result;
    };
  }]);

